import { createReducer, on } from "@ngrx/store";
import { Offer } from "../../models/offer";
import { loadOfferByIdAct, recalculateSuccessOfferAct, 
    resetOfferAct, saveSuccessOfferAct, setViolationsOfferAct, getSignaturesSuccessOfferAct, 
    updateSuccessOfferAct, 
    showMsgErrorAct,
    saveOfferAct,
    findOfferAct,
    sendSignaturesSuccessOfferAct,
    getSignaturesOfferAct,
    recalculateOfferAct} from "./offer.actions";

const offer: Offer = new Offer();

export const offerReducer = createReducer (
    {
        offer,
        violations: {},
        loading: true
    },
    on(resetOfferAct, (state) => ({
        offer:  { ...offer },
        violations: {},
        loading: state.loading
    })),
    on(findOfferAct, (state) => ({
        offer:  { ...offer },
        violations: {},
        loading: true
    })),
    on(loadOfferByIdAct, (state, { offer }) =>({
        offer: { ...offer}, 
        violations: state.violations,
        loading: false
    })),
    on(saveSuccessOfferAct, (state, { offerNew }) => ({
        offer: { ...offerNew },
        violations: {},
        loading: state.loading
    })),
    on(updateSuccessOfferAct, (state, { offerUpdated }) => ({
        offer: { ...offerUpdated },
        violations: {},
        loading: state.loading
    })),
    on(setViolationsOfferAct, (state, { offerForm, violations }) => ({
        offer: { ...offerForm },
        violations: {...violations},
        loading: false 
    })),
    on(recalculateOfferAct, (state, { offerRecalculate }) => ({
        offer: { ...offerRecalculate },
        violations: {},
        loading: true
    })),
    on(recalculateSuccessOfferAct, (state, { offerRecalculate }) => ({
        offer: { ...offerRecalculate },
        violations: {},
        loading: false
    })), 
    on(getSignaturesOfferAct, (state, { offerSignature }) => ({
        offer: { ...offerSignature },
        violations: {},
        loading: true
    })),
    on(getSignaturesSuccessOfferAct, (state, { offerSignature }) => ({
        offer: { ...offerSignature },
        violations: {},
        loading: false
    })),
    on(sendSignaturesSuccessOfferAct, (state, { offerSendSignature }) => ({
        offer: { ...offerSendSignature },
        violations: {},
        loading: state.loading
    })),
    on(saveOfferAct, (state, { offerNew }) => ({
        offer: { ...offerNew },
        violations: {},
        loading: state.loading 
    })),
    on(showMsgErrorAct, (state, {  }) => ({
        offer: state.offer,
        violations: {},
        loading: false
    }))

);